var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "grid grid-cols-8 gap-x-4 gap-y-3" };
const _hoisted_2 = { class: "col-span-3" };
const _hoisted_3 = { class: "col-span-3" };
import { CheckCircleIcon, Copy01Icon } from '@gohighlevel/ghl-icons/24/outline';
import { UIButton, UIInput, UIInputGroup, UITextSmMedium, } from '@gohighlevel/ghl-ui';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DomainConnectRecordTable',
    props: {
        recordTableData: null
    },
    setup(__props) {
        const { t } = useI18n();
        const copyButtonId = ref();
        const copyText = (text, id) => __awaiter(this, void 0, void 0, function* () {
            try {
                yield navigator.clipboard.writeText(text);
                copyButtonId.value = id;
                setTimeout(() => {
                    copyButtonId.value = undefined;
                }, 2000);
            }
            catch (err) {
                console.error(err);
                copyButtonId.value = undefined;
                window.alert(t('copiedToClipboardNotificationError'));
            }
        });
        const getRecordId = (key, item) => {
            return `${key}-${item.record}${item.host}${item.value}`;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(UITextSmMedium), { class: "col-span-2" }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('record')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_unref(UITextSmMedium), { class: "col-span-3" }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('host')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_unref(UITextSmMedium), { class: "col-span-3" }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('requiredValue')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.recordTableData, (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                        key: item.value
                    }, [
                        _createVNode(_unref(UIInput), {
                            class: "col-span-2",
                            id: item.record + item.value,
                            disabled: true,
                            "model-value": item.record
                        }, null, 8 /* PROPS */, ["id", "model-value"]),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_unref(UIInputGroup), null, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UIInput), {
                                        id: item.host + item.value,
                                        "model-value": item.host,
                                        readonly: true
                                    }, null, 8 /* PROPS */, ["id", "model-value"]),
                                    _createVNode(_unref(UIButton), {
                                        onClick: ($event) => (copyText(item.host, getRecordId('host', item))),
                                        id: item.record + item.value
                                    }, {
                                        default: _withCtx(() => [
                                            (copyButtonId.value === getRecordId('host', item))
                                                ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                                                    key: 0,
                                                    class: "w-6"
                                                }))
                                                : (_openBlock(), _createBlock(_unref(Copy01Icon), {
                                                    key: 1,
                                                    class: "w-6"
                                                }))
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "id"])
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */)
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(_unref(UIInputGroup), null, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UIInput), {
                                        id: item.value,
                                        "model-value": item.value,
                                        readonly: true
                                    }, null, 8 /* PROPS */, ["id", "model-value"]),
                                    _createVNode(_unref(UIButton), {
                                        onClick: ($event) => (copyText(item.value, getRecordId('value', item))),
                                        id: item.value
                                    }, {
                                        default: _withCtx(() => [
                                            (copyButtonId.value === getRecordId('value', item))
                                                ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                                                    key: 0,
                                                    class: "w-6"
                                                }))
                                                : (_openBlock(), _createBlock(_unref(Copy01Icon), {
                                                    key: 1,
                                                    class: "w-6"
                                                }))
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "id"])
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */)
                        ])
                    ], 64 /* STABLE_FRAGMENT */));
                }), 128 /* KEYED_FRAGMENT */))
            ]));
        };
    }
});
